import { useEffect } from "react";

import useCustomerDetails from "../data/useCustomerDetails";

const tailwindShades = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900];

/**
 * Applies the customer's primary palette as the --primary-* CSS variables Tailwind reads.
 * DashboardLayout does the same inline; layouts without the dashboard chrome (the till)
 * need it too or they render in the default palette.
 */
export default function useBrandTheme() {
  const { brand } = useCustomerDetails();

  useEffect(() => {
    const colours = brand.data?.data?.primaryTailwindColours;
    if (!colours) return;

    tailwindShades.forEach((shade) => {
      const value = colours[shade];
      if (value) document.documentElement.style.setProperty(`--primary-${shade}`, value);
    });
  }, [brand.data]);

  return brand;
}
